/*
* Created on Jan 22, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useState} from 'react';
import ic_edit_svg from "../../static/img/utils/ic-edit.svg";
import GroupEditModalComponent from "./GroupEditModalComponent";
import {useTimezone} from "../../service/timezone";
import {dataCellLabelToDataGridArea} from "../../service/utils";

const GroupTableRowComponent = ({ row_data, index, doRefresh, disPatcher, translate:t, isOwner, show_checkbox=false, table_head_fields}) => {

    const onClickOpenModal = (data) => {
        disPatcher({type:'open_edit_modal', payload: data});
    }

    const toggle_checkbox = (row) => {
        disPatcher({type:'toggle_checkbox', payload: row});
    }

    return (
        <div className="flexbox-trow" key={index}>
            <div className="tbody-cell select-cell">
                <div className={`comp-checkbox no-label ${show_checkbox ? 'visible-checkbox' : ''}`}>
                    <input type="checkbox" id={`cb-${row_data.organization_group_id}`}
                           disabled={!isOwner}
                           checked={row_data.checked || false}
                           onChange={()=>toggle_checkbox(row_data)}
                    />
                    <label htmlFor={`cb-${row_data.organization_group_id}`} className="comp-label"> </label>
                </div>
            </div>
            <div className="tbody-cell !w-20" data-cell-label={t(table_head_fields[0].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[0].field_name)}>{row_data.name}</div>
            <div className="tbody-cell !w-25" data-cell-label={t(table_head_fields[1].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[1].field_name)}>{row_data.description}</div>
            <div className="tbody-cell !w-25" data-cell-label={t(table_head_fields[2].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[2].field_name)}>
                <div className="tag-group">
                    {row_data.users.filter((u)=>u?.id).length > 0 && <span className="tag">{row_data.users[0]?.display_name || row_data.users[0].email}</span>}
                    {row_data.users.filter((u)=>u?.id).length > 1 && (
                        <>
                        <span className="tag tag-more">+ {row_data.users.filter((u)=>u?.id).length-1}</span>
                        <div className="popover read-only group-tooltip">
                            <ul className="popover-menu">
                                <li className="section">
                                    {row_data.users.filter((u)=>u?.id).map((user,index)=>{
                                        return <div className="section-items" key={index}>{user?.display_name || user.email}</div>
                                    })}
                                </li>
                            </ul>
                        </div>
                        </>
                    )}
                </div>
            </div>
            <div className="tbody-cell !w-20" data-cell-label={t(table_head_fields[3].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[3].field_name)}>{useTimezone(row_data.created_at)}</div>
            <div className="tbody-cell !w-10" data-cell-label={t(table_head_fields[4].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[4].field_name)}>
                <div className="act-btn-group">
                    {/*<div className="act-btn" onClick={()=>{setOpenModal(true)}}>*/}
                    { isOwner &&
                    <div className="act-btn" onClick={()=>{onClickOpenModal(row_data)}}>
                        <img src={ic_edit_svg} alt="" />
                    </div>
                    }
                </div>
            </div>

            {/*{row_data && <GroupEditModalComponent openModal={openModal} closeModal={closeModal} group_data={row_data} doRefresh={doRefresh}/>}*/}
        </div>
    );
};

export default GroupTableRowComponent;